import axios from "axios";
import { toast } from "react-toastify";
import { CONTACT_SUCCESS, GET_CONTACTS } from "../constant/Type";
import { BASE_URL } from "../constant/URL";

//GET contact DETAILS
export const getContacts = () => async (dispatch) => {
  try {
    const res = await axios.get(`${BASE_URL}/api/v1/contact`, {
      withCredentials: true,
    });
    dispatch({
      type: GET_CONTACTS,
      payload: res.data.data,
    });
  } catch (err) {
    console.log(err);
  }
};

// Submit ACTION
export const contactSubmit = (values) => async (dispatch) => {
  let formData = {
    name: values.name,
    email: values.email,
    country: values.country,
    companyName: values.company,
    message: values.message,
  };

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  };
  try {
    await axios.post(
      `${BASE_URL}/api/v1/contact`,
      JSON.stringify(formData),
      config
    );
    dispatch({
      type: CONTACT_SUCCESS,
    });

    toast.success("Your response is recorded!");
    return true;
  } catch (err) {
    toast.error(err.response.data.message);
    return false;
  }
};
